.form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: var(--t-dense);
  font-weight: 600;
  color: var(--ink-2);
}

.field input,
.field select {
  height: var(--h-ctl);
  padding: 0 10px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-chip);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-weight: 400;
}

.field input:focus-visible,
.field select:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 1px;
}

.hint {
  margin: 0;
  color: var(--muted);
  font-size: var(--t-dense);
  line-height: 1.45;
}

.primary,
.ghost {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: var(--h-ctl);
  padding: 0 14px;
  border-radius: var(--radius-chip);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}

.primary {
  border: 1px solid var(--accent);
  background: var(--accent);
  color: var(--on-fill);
}

.primary:hover:not(:disabled) {
  border-color: var(--accent-h);
  background: var(--accent-h);
}

.primary:disabled {
  border-color: var(--btn-off-bg);
  background: var(--btn-off-bg);
  color: var(--btn-off-ink);
  cursor: not-allowed;
}

.ghost {
  border: 1px solid var(--line-2);
  background: var(--panel);
  color: var(--ink-2);
}

.ghost:hover {
  border-color: var(--muted);
  background: var(--panel-2);
  color: var(--ink);
}

.primary:focus-visible,
.ghost:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.exchange {
  margin: 0;
  padding: 0;
  list-style: none;
}

/* The vendor's name in the table: a button that looks like the product's own link (a name that opens something is
   in the action colour, and the focus ring is the same 2px ring every control has). */
.openName {
  display: inline;
  max-width: 100%;
  padding: 0;
  border: 0;
  background: none;
  color: var(--accent);
  font: inherit;
  text-align: left;
  text-underline-offset: 3px;
  cursor: pointer;
}

.openName:hover {
  color: var(--accent-h);
  text-decoration: underline;
}

.openName:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
  border-radius: 3px;
}
